var frameJS = '/pegasus/assets/landing_page_widgets.js';
var sufJS = '/pegasus/assets/signup_forms.js';
var formJS = '/pegasus/assets/form_js.js';

Pegasus.InitializeSignupForms = Em.Mixin.create({
  initializeIFrames: function(frame){
    var doc = frame.contentWindow.document;
    var script = doc.createElement("script");
    script.type = "text/javascript";
    script.src = frameJS;
    doc.body.appendChild(script);
  },

  initializeForms: function(frame){
    var doc = frame.contentWindow.document;
    var win = doc.defaultView || doc.parentWindow;
    win.reallySubmit = false;

    var script = doc.createElement("script");
    script.type = "text/javascript";
    script.src = sufJS;
    doc.body.appendChild(script);

    var script = doc.createElement("script");
    script.type = "text/javascript";
    script.src = formJS;
    doc.body.appendChild(script);
  }
});
